/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ASSET_VALUATION_SUCCESS,
  GET_ASSET_VALUATION_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  valuation: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
      case GET_ASSET_VALUATION_SUCCESS:
          return {
              getAssetValuationSuccess: true,
              valuation: action.payload.valuation,
          }
      case GET_ASSET_VALUATION_FAILURE:
          return {
            getAssetValuationSuccess: false,
            valuation: state.valuation,
          }

      default:
          return state;
  }
}

